import {
  getDealerDealerId,
  getV1DealerDealerIdEmployees,
  type DomainDealerEmployee,
  type DtoDealer,
} from "@porchpass/api-client";
import { assertApiSuccess } from "../utils/assertApiSuccess";
import { requireDealerId } from "./types";

export function createDealerDomain(dealerId: string) {
  return {
    getDealer: async (dealerName: string): Promise<DtoDealer> => {
      const response = await getDealerDealerId(dealerName, {
        dealer_id: dealerName,
      });
      return assertApiSuccess<DtoDealer>(response);
    },

    getEmployees: async (): Promise<DomainDealerEmployee[]> => {
      const id = requireDealerId(dealerId);
      const response = await getV1DealerDealerIdEmployees(id);
      return assertApiSuccess<DomainDealerEmployee[]>(response);
    },
  };
}
